import Vue from 'vue'
import { createApp } from 'vue'
// import VueRouter from 'vue-router';
import App from '@/App.vue'
import Router from '@/router'
import AuthService from '@/AuthService'
import ApiService from '@/apiService'
import VueMatomo from 'vue-matomo'
import State from '@/state.js'
import VueHtml2pdf from 'vue-html2pdf'

import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const app = createApp(App);

//import a section of this package to use, in this case the 'library' part. This is base data for our fonts
//Note: I followed FA docs to learn how to add to Vue
import { library } from '@fortawesome/fontawesome-svg-core'
//pull out the individual icons we want to use in our app so we dont load unnecessary fonts and bloat the code
import {
  faSearch,
  faInfoCircle,
  faQuestionCircle,
  faSignInAlt,
  faExternalLinkSquareAlt,
  faExternalLinkAlt,
  faImage
} from '@fortawesome/free-solid-svg-icons'
//pull in some additional FA data we need according to FA docs
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap/dist/js/bootstrap.bundle';
// import '@/plugins/vue-html2pdf';
// import custom css as well as all bootstrap css
// not needed since im using css loader via config
import '@/_custom.scss'
import '@/cndBootstrap.min.css'
// instead of loading the entire Bootstrap js file below, we are going to import them into individual components as needed to minimize bloat
//import 'bootstrap.js';
import 'animate.css'
//a custom spinner component i made for this app. It's just a basic Vue template with CSS!
import Spinner from '@/components/Spinner.vue'

//we are loading the below components now because we need to use them in the Vue Router

//imported jquery for now because needed toggling logic for datadetails component..hope to use straight JS when I get time
//window.$ = window.jQuery = require('jquery');

//FA docs said to globally add our cherrypicked icons to our library package from above
library.add(
  faSearch,
  faInfoCircle,
  faQuestionCircle,
  faSignInAlt,
  faExternalLinkSquareAlt,
  faExternalLinkAlt,
  faImage
);

app.config.productionTip = false;
// app.use(VueRouter);
app.use(BootstrapVue);
var VueScrollTo = require('vue-scrollto');
app.use(VueScrollTo);
app.use(VueHtml2pdf);

//register globally for usage throughout app; use html w3c standards for element names. Now we can just plug them in our components as needed! Our, we could have just imported these individually into each component as needed, but that's too much work since we are using multiple components with these elements. Easier just to make these global.
app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('SpinnerLoaderIcon', Spinner);

// setup as shown here https://router.vuejs.org/guide/advanced/meta.html#route-meta-fields
// router.beforeEach((to, from, next) => {
//   const token = window.localStorage.getItem('tokens-gx');
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     //also, turn on 'GeoAxis' if needed. See 'config.json' in src
//     if (token == null || Config.geoAxis == false) {
//       next('/');
//     } else if (token != null && Config.geoAxis) {
//       next();
//     }
//   } else {
//     next(); // make sure to always call next() to close the pipeline!
//   }
// });


//Only run Matomo analytics if app is in production mode and specific domain
if (
  process.env.NODE_ENV == 'production' &&
  window.location.hostname == 'fgs-dps.gs.mil'
) {
  app.use(VueMatomo, {
    // Configure your matomo server and site
    host: '//webanalytics.nga.mil',
    siteId: 414,

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Enables automatically registering pageviews on the router
    router: Router,

    // Enables link tracking on regular links. Note that this won't
    // work for routing links (ie. internal Vue router links)
    // Default: true
    enableLinkTracking: true,

    // Require consent before sending tracking information to matomo
    // Default: false
    requireConsent: false,

    // Whether to track the initial page view
    // Default: true
    trackInitialView: true,

    // Changes the default .js and .php endpoint's filename
    // Default: 'piwik'
    trackerFileName: 'piwik',

    // Whether or not to log debug information
    // Default: false
    debug: false
    // trackInteraction: (to, from) => {
    //   // If this is the first route visited, then always record a page visit
    //   if (!from) {
    //     return true;
    //   }
  
    //   // Return true if the path or hash changed, but not anything else
    //   return to.path !== from.path || to.hash !== from.hash;
    // },
  });

  // this.$matomo && this.$matomo.trackPageView()
}

// new Vue({
//   //State is imported immutable global data that you may want to use in other parts of the app. In a more complex app we shoud use the VUEX library
//   data: State,
//   created: function() {
//     //check for response parameters if user has an auth token (uses JSO plugin)
//     AuthService.authCallBack();
//   },
//   render: h => h(App),
//   router: Router
// }).$mount('#app');

// createApp(App).use(Router).mount('#app')
// createApp(App,{
//   data() {
//     return {
//       data: State,
//       created: function() {
//         //check for response parameters if user has an auth token (uses JSO plugin)
//         AuthService.authCallBack();
//       }
//     }
//   }
//   //State is imported immutable global data that you may want to use in other parts of the app. In a more complex app we shoud use the VUEX library
  
  
// })
app.use(State);
app.use(Router).mount('#app');

// createApp(App).use(Router).mount('#app')
